import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9c434fe0&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c434fe0')) {
      api.createRecord('9c434fe0', component.options)
    } else {
      api.reload('9c434fe0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9c434fe0&", function () {
      api.rerender('9c434fe0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MenuTree/index.vue"
export default component.exports